import { memo } from 'react';

import { type DragLibraryItem } from '~/components/Shared/Drag/dragTypes';

export type LibraryDragPreviewProps = {
  library: DragLibraryItem;
};

export const LibraryDragPreview = memo(({ library }: LibraryDragPreviewProps) => {
  return (
    <div className="flex w-60 items-center gap-3 rounded-8 ads:bg-subtle bg-gray-3 px-2 py-2 shadow-drag-preview">
      <div
        className="flex size-6 shrink-0 items-center justify-center rounded-4 ads:bg-subtle bg-gray-4 text-14 ads:ring-default ring-1 ring-gray-4"
        // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the color pairing
        style={{ backgroundColor: library.library.color?.backgroundHex }}
      >
        {/* biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the color pairing */}
        <span>{library.library.icon ?? '📚'}</span>
      </div>
      <div className="truncate ads:text-secondary text-14 text-gray-11">{library.library.title}</div>
    </div>
  );
});

LibraryDragPreview.displayName = 'LibraryDragPreview';
